<mat-card appearance="outlined">
    <form class="fix-editor">
        <mat-form-field class="ag-row fix-mat-form" [style.width]="width()">
            <input
                matInput
                [formControl]="letterFormControl()"
                [sanitizeChars]="notAdmissibleCharsRegexp()"
                [focusSelectOn]="cellReady()"
            />
            @if (letterFormControl().hasError("required")) {
                <mat-error>
                    {{ "se-ui-datagrid_required_value_constraint" | translate }}
                </mat-error>
            }
        </mat-form-field>
    </form>
</mat-card>
